import { ILocationSearchItemFragment } from 'transfix-maps/hooks/useLocationSearch'
import { IAutocompleteBaseOption } from 'transfix-ui/components/AutocompleteBase'
import {
  usStatesOptions,
  canadianStatesOptions,
  COUNTRIES,
  ICountry,
  IStateOption,
} from 'constants/countriesStates'

/**
 * Generates an autocomplete option for a given state
 */
const getStateCodeOption = (stateOption: IStateOption, country: ICountry) => {
  const { code: countryCode, name: countryName } = country || {}
  const { label: stateName, value: stateCode } = stateOption || {}
  return {
    id: stateCode,
    text: `${stateName}, ${countryName}`,
    data: {
      country: countryName,
      countryCode,
      state: stateName,
      stateCode,
    },
    groupIndex: 1,
  } as IAutocompleteBaseOption<ILocationSearchItemFragment>
}

/**
 * Returns options that correspond with a state value
 */
export const getStateAutocompleteOption = (inputValue: string) => {
  if (inputValue && inputValue.length === 2) {
    const usState = usStatesOptions.find(state => inputValue.toUpperCase() === state.value)
    if (usState) return [getStateCodeOption(usState, COUNTRIES[0])]
    const caState = canadianStatesOptions.find(state => inputValue.toUpperCase() === state.value)
    if (caState) return [getStateCodeOption(caState, COUNTRIES[1])]
  }
  return []
}
